import { render, staticRenderFns } from "./DetailLock.vue?vue&type=template&id=6b5edec0&scoped=true"
import script from "./DetailLock.vue?vue&type=script&lang=js"
export * from "./DetailLock.vue?vue&type=script&lang=js"
import style0 from "./DetailLock.vue?vue&type=style&index=0&id=6b5edec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5edec0",
  null
  
)

export default component.exports